<button type="button" class="btn btn-success {{class}}" [ngClass]="{'btn-sm': small}" [disabled]="disabled"
  placement="{{tooltipPlacement}}" container="body" [ngbTooltip]="tooltip"
    (click)="onBtnClick(); $event.stopPropagation()">
     <i *ngIf="showIcon || !showCaption" class="fas fa-check"></i>
     <span *ngIf="showIcon && showCaption">&nbsp;</span><span *ngIf="showCaption">{{caption}}</span>
</button>
